import {mapMutations, mapActions, mapGetters} from 'vuex'
import appTextfieldLazy from '@/components/app-textfield-lazy/index.vue'
import _ from "lodash";

export default {
  name: 'notificationsFilter',
  //---components
  components: {
    appTextfieldLazy
  },
  //---data
  data () {
    return {
      statusData: {
        list: [
          {
            id: 'today',
            title: 'Due Today Notifications'
          },
          {
            id: 'all',
            title: 'All Notifications'
          },
          {
            id: 'closed',
            title: 'Closed Notifications'
          },
        ],
        current: 'today'
      },
      searchData: null,
    }
  },
  //---hooks
  created: function () {
    this.getFiltersChange();
  },
  computed: {
    ...mapGetters({
      notificationsMeta: 'NOTIFICATIONS/notificationsMeta'
    }),
  },
  //---methods
  methods: {
    ...mapMutations({
      loaderFlag: 'APP/APP_LOADER_FLAG_TOGGLE',
      setNotificationsFilters: 'NOTIFICATIONS/NOTIFICATIONS_FILTERS_SET',
      setNotificationsMeta: 'NOTIFICATIONS/NOTIFICATIONS_META_SET',
    }),
    ...mapActions({
      getNotifications: 'NOTIFICATIONS/NOTIFICATIONS_REQUEST_GET'
    }),
    getFiltersChange() {
      this.loaderFlag(true);

      let dataForRequest = {
        type: this.statusData.current,
        search: this.searchData ? this.searchData : ''
      };

      let notificationsMeta = _.cloneDeep(this.notificationsMeta);
      notificationsMeta.pageId = 1;
      this.setNotificationsMeta(notificationsMeta);

      this.setNotificationsFilters(dataForRequest);
      this.getNotifications().finally(() => {
        this.loaderFlag(false);
      });
    },
  }
}